export const SAVE_ALL_HOLIDAYS = 'SAVE_ALL_HOLIDAYS'